// Informacja o projekcie dofinansowanym z Funduszu Ubezpieczeń Społecznych.
// Wymagane elementy: rozporządzenie RM z 7 maja 2021 r. (Dz.U. 2021 poz. 953), § 7.
// Grafika z barwami i godłem RP to oficjalny plik KPRM "znaki na stronę www"
// (gov.pl/web/premier/dzialania-informacyjne) – nie modyfikować.
import znakiRP from '../assets/images/dofinansowanie/znaki_strona_www.png';

export const DOFINANSOWANIE = {
  path: '/dofinansowanie',
  znakiRP,
  naglowek: 'Rafał Łopatka „Rafloor” realizuje projekt dofinansowany z Funduszu Ubezpieczeń Społecznych',
  program: 'Program dofinansowania płatników składek w ramach prewencji wypadkowej',
  zadanie: 'Poprawa bezpieczeństwa i odciążenie układu mięśniowo-szkieletowego w firmie Rafał Łopatka „Rafloor”',
  opis: [
    'Głównym celem projektu jest poprawa warunków pracy pracowników, zmniejszenie zagrożeń występujących na stanowiskach pracy oraz zmniejszenie zagrożenia przeciążenia układu ruchu pracowników.',
    'Celem poszczególnych działań inwestycyjnych jest zakup urządzeń służących poprawie bezpieczeństwa pracy na wysokości oraz zakup urządzeń odciążających układ mięśniowo-szkieletowy.',
  ],
  dataUmowy: 'grudzień 2025 r.',
  // Kwoty z umowy (wymóg § 7 ust. 1 pkt 5). \u00A0 = twarda spacja, żeby kwota nie łamała się w połowie.
  // Puste pola nie są wyświetlane.
  dofinansowanie: '54\u00A0908,91 zł',
  wartoscCalkowita: '68\u00A0636,14 zł',
};